module.exports = __webpack_public_path__ + "static/media/gallery-img-8.55a6342b.jpg";